export default __webpack_public_path__ + "static/media/ex2.3dd9a683.png";